export default "__VITE_ASSET__BxOHI1sT__"